export default (client) => ({
  get(id) {
    return client.request({
      method: 'get',
      url: `/new-users/get/${id}`,
    });
  },
  find(filterParams) {
    return client.request({
      method: 'get',
      url: '/new-users',
      params: { ...filterParams },
    });
  },
  create(payload) {
    return client.request({
      method: 'post',
      url: '/new-users',
      data: payload,
    });
  },
  patch(id, payload) {
    return client.request({
      method: 'patch',
      url: `/new-users/${id}`,
      data: payload,
    });
  },
});
